'use client'
import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'

export function RouteProgress() {
  const pathname = usePathname()
  const [loading, setLoading] = useState(false)
  const [progress, setProgress] = useState(0)

  // legitimate external sync: ticker-driven progress animation on pathname change
  /* eslint-disable react-hooks/set-state-in-effect */
  useEffect(() => {
    setLoading(true)
    setProgress(30)
    const t1 = setTimeout(() => setProgress(60), 100)
    const t2 = setTimeout(() => setProgress(80), 200)
    const t3 = setTimeout(() => { setProgress(100) }, 300)
    const t4 = setTimeout(() => { setLoading(false); setProgress(0) }, 500)
    return () => {
      clearTimeout(t1)
      clearTimeout(t2)
      clearTimeout(t3)
      clearTimeout(t4)
    }
  }, [pathname])

  /* eslint-enable react-hooks/set-state-in-effect */
  if (!loading) return null

  return (
    <div className="fixed top-0 start-0 end-0 z-[99999] h-0.5 bg-primary/20">
      <div
        className="h-full bg-primary transition-all duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}
